module.exports = __webpack_public_path__ + "img/humidity_sensor.d1cb937c.svg";